// rozbalovaci hamburger menu
$(document).ready(function () {
    if(window.innerWidth > 728 && window.innerWidth < 1024) {
       $(".toggle_menu, #side_left, #side_right").addClass("is_active"); 
    }    

    $('.toggle_menu').click(function() {
        $('.toggle_menu, #side_left, #side_right').toggleClass('is_active');
    });

    if(window.innerWidth > 728) {
        $('.main_navigation li').click(function() {
            $('.toggle_menu, #side_left, #side_right').removeClass('is_active');
        });
     } 
});


// taby
$('#responsiveTabs').responsiveTabs();

$('#channelSelectTabs').responsiveTabs();

$('#responsiveTabsDB').responsiveTabs();


// taby v popupu
$('#responsiveTabsPopup').responsiveTabs();


// subTabs
$('#subTabs').responsiveTabs();


// kalendar
$( function() {
    $( ".datepicker_init" ).datepicker();
} );

$( function() {
    $( ".datepicker_init_range" ).datepicker({ 
        minDate: -20,
        maxDate: 20 
    });
} );


// rozsireny filtr
$( function() {
    $( ".expand" ).on( "click", function() {
        $( ".advanced_filter_content, .expand" ).toggleClass( "open");
    });
} );


// novy porad
$( function() {
    $( ".add_show" ).on( "click", function() {
        $( ".search_db, .add_show" ).toggleClass( "open");
    });
} );


// rozbaleni sluzeb v detailu
$( function() {
    $( ".add_expand" ).on( "click", function() {
        //$( ".expand_content, .add_expand" ).toggleClass( "open");
        $(this).toggleClass("open");
        $(this).parent().next().toggleClass("open");
    });
} );


// pridani noveho platce
$( function() {
    $( ".add_payer a" ).on( "click", function() {
        $( ".new_payer, .add_payer" ).toggleClass( "open");
    });
    $( ".new_payer .btn_delete" ).on( "click", function() {
        $( ".new_payer, .add_payer" ).removeClass( "open");
    });
} );


// rozsireny vypis tabulky
$(function() {
    $('.more_info').click(function() {
        if($(this).next().has('.open')) {
            $('.more_info').removeClass('open');
            $('.more_info').next().removeClass('open');
            $(this).toggleClass('open');
            $(this).next().toggleClass('open');
        }
    });
});


// checkbox prirazene sluzby pro odberatele
$(document).ready(function() {
  $('.expand_content_line_inner input[type="checkbox"]').on('change.symptom', function() {
    $(this).parent().parent().next().toggleClass('open', this.checked);
  }).trigger('change.symptom');
});


// proklik celeho radku tabulky
jQuery( function($) {
    $('tbody tr[data-href]').addClass('clickable').click( function() {
        window.location = $(this).attr('data-href');
    }).find('a, .drag_drop span, label').hover( function() {
        $(this).parents('tr').unbind('click');
    }, function() {
        $(this).parents('tr').click( function() {
            window.location = $(this).attr('data-href');
        });
    });
});


// drag and drop vypisu
$('.vypis .sortable').sortable({
    helper: fixWidthHelper
}).disableSelection();
    
function fixWidthHelper(e, ui) {
    ui.children().each(function() {
        $(this).width($(this).width());
    });
    return ui;
}


// drag and drop skupiny stanic
$( function() {
    $( "#dashboardContent, #availableShowGroups" ).sortable({
        connectWith: ".group_column_items",
        revert: 300,
        scrollSpeed: 30,
        scrollSensitivity: 120,
        tolerance: "pointer",
    });
} );


// drag and drop table settings
$( function() {
    $( ".selected_cols ul" ).sortable({
        axis: "y",
        revert: 300,
        scrollSpeed: 30,
        scrollSensitivity: 120,
        tolerance: "pointer",
    });
} );


// rozbalovani side_tab
jQuery(document).ready(function($) {
    var open = false;

    var openSideTab = function(){
    $('.side_tab, .side_tab_box').addClass('active');
    open = true;
}
var closeSideTab = function(){
    $('.side_tab, .side_tab_box').removeClass('active');
    open = false;
}

$('.side_tab, .close').click( function(event) {
    event.stopPropagation();
    var toggle = open ? closeSideTab : openSideTab;
    toggle();
});

});


// vkladani class pri zaskrtnuti radio buttonu v pridavani epizod
$('.add_episode .field_radio label, .episode_db .field_radio label').click(function () {
    $('.add_episode .field_radio label, .episode_db .field_radio label').parent().parent().removeClass('open');
    $(this).parent().parent().addClass('open');
});

$('.add_episode .field_radio input:checked, .episode_db .field_radio input:checked').parent().parent().addClass('open');


// vyber jazyka
$(".language span").click(function(event){
    $(this).parent().toggleClass('active');
    event.stopPropagation();
})

$("body").click(function(event){
    $('.language').removeClass('active');
})


// dropdown
$('.btn_dropdown').click(function(event){
    $('.dropdown_content').toggleClass('open');
    $('.btn_dropdown').toggleClass('active');
    event.stopPropagation();
})

$(window).click(function(event){
    $('.dropdown_content').removeClass('open');
    $('.btn_dropdown').removeClass('active');
})

$('.dropdown_content').click(function(event){
    event.stopPropagation();
});


// simulace naseptavace + mazani vyhledavaciho pole
$('.field_search .search').on('click', function(e) {
    $('.field_search, .extended_search, .field_left').removeClass('extended');
    $(this).siblings('.extended_search').addClass('extended');
    $(this).parent().addClass('extended');
    $(this).parent().parent().addClass('extended');
    e.stopPropagation();
});
  
$('html').click(function(e) {                    
    if (!$(e.target).hasClass('clearable_btn') && !$(e.target).hasClass('search') && !$(e.target).closest('.extended_search').length) {
        $('.field_search, .field_search .extended_search').removeClass('extended');
    }
});

$('.search').each(function() {
    if ($(this).val()) {
        $(this).siblings('.clearable_btn').show();
    }
    else {
        $(this).siblings('.clearable_btn').hide();
    }
});
$(".search").keyup(function () {
    if ($(this).val()) {
        $(this).siblings('.clearable_btn').show();
    }
    else {
        $(this).siblings('.clearable_btn').hide();
    }
});
$(".clearable_btn").click(function () {
    $(this).siblings('.search').val('').focus();
    $(this).hide();
});


// mazani datepickeru
$('.datepicker, .datepicker_range, .search').each(function() {
    if ($(this).val()) {
        $(this).siblings('.clearable_btn').show();
    }
    else {
        $(this).siblings('.clearable_btn').hide();
    }
});
$('.datepicker, .datepicker_range, .search').change(function() {
    if ($(this).val()) {
        $(this).siblings('.clearable_btn').show();
    }
    else {
        $(this).siblings('.clearable_btn').hide();
    }
});

$(".clearable_btn").click(function () {
    $(this).siblings('.datepicker, .datepicker_range').val('');
    $(this).hide();
});


// main menu
$(".has_subpages a").click(function(){
    //$(".has_subpages").removeClass("active");
    $(this).parent().toggleClass("active");
});

( function( $ ) {
    $( 'a[href="#"]' ).click( function(e) {
       e.preventDefault();
    } );
 } )( jQuery );


 // rozbalovani souboru
$(".accordion .left h2").click(function(){
    $(this).parent().parent().toggleClass("extended");
});


// scroll to top
$(document).ready(function () {

    $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            $('.scrollup').addClass('visible');
        } else {
            $('.scrollup').removeClass('visible');
        }
    });

    $('.scrollup').click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, 300);
        return false;
    });

});

// razeni polozek v seznamu
$( function() {
    $( "#sortable" ).sortable();
} );


// custom file input
$('.file-upload, .input_file').change(function() {
    var i = $(this).prev('label').clone();
    var file = $('.file-upload, .input_file')[0].files[0].name;
    $(this).prev('label').text(file);
  });


// nastavení rozsahu
$( function() {
    $( "#rating-range" ).slider({
        range: true,
        min: 0,
        max: 100,
        values: [ 0, 100 ],
        slide: function( event, ui ) {
        $( "#rating-range-total" ).val( ui.values[ 0 ] + "–" + ui.values[ 1 ] + " %" );
        }
    });
    $( "#rating-range-total" ).val( $( "#rating-range" ).slider( "values", 0 ) +
        "–" + $( "#rating-range" ).slider( "values", 1 ) + " %" );
} );

$( function() {
    $( "#year-range" ).slider({
        range: true,
        min: 1900,
        max: 2021,
        values: [ 1900, 2021 ],
        slide: function( event, ui ) {
        $( "#year-range-total" ).val( ui.values[ 0 ] + "–" + ui.values[ 1 ] );
        }
    });
    $( "#year-range-total" ).val( $( "#year-range" ).slider( "values", 0 ) +
        "–" + $( "#year-range" ).slider( "values", 1 ) );
} );


// zobrazení a skrytí hesla
$(".show_password").click(function() {
    $(this).toggleClass("hide_password");
    var input = $($(this).attr("toggle"));
    if (input.attr("type") == "password") {
      input.attr("type", "text");
    } else {
      input.attr("type", "password");
    }
});


// kopírování inputu pomocí tlačítka
$(".copy_icon").click(function() {
    var inputSelector = $(this).prev("input");
    var inputValue = inputSelector.val();
    copyToClipboard(inputValue, $(this));
});

function copyToClipboard(value, button) {
    var tempInput = $("<input>");
    $("body").append(tempInput);
    tempInput.val(value).select();
    document.execCommand("copy");
    tempInput.remove();
    button.addClass("copied");
    setTimeout(function() {
    button.removeClass("copied");
    }, 3000);
}


// přepínání switche
$(".switch").attr("title", "Zobrazit výslednou konfiguraci").click(function(){
    $(this).toggleClass("switched");
    var title = "Zobrazit výslednou konfiguraci";

    if( $(this).hasClass("switched")){
        title = "Zobrazit editační mód";
    }
    $(this).attr("title", title);
});


// zobrazení/skrytí časové osy v EPG
$(".epg_name").click(function(){
    if (!$(this).parent().hasClass("active")) {
        $(".epg_show").removeClass("active");
    }
    $(".epg_progressbar_element").removeClass("show");
    $(this).parent().toggleClass("active");
});


// duplikace zámku do tagu tr ve výpisu - mobil/tablet
$(document).ready(function() {
    var lockElements = $('.vypis .no_padding .lock');

    lockElements.each(function() {
        var lockElementClone = $(this).clone();
        var trElement = $(this).closest('tr');
        trElement.append(lockElementClone);
    });
});


// nastavení stejné šířky pro item_id v extended_search
$(document).ready(function() {
    $('.extended_search').each(function() {
      var longestWidth = 0;

      $(this).find('.item_id').each(function() {
        var sirka = $(this).width();
        if (sirka > longestWidth) {
          longestWidth = sirka;
        }
      });

      $(this).find('.item_id').width(longestWidth);
    });
});


//inicializace crop portrait
var $image = $('#crop_portrait');

if ($image.length) {
    cropper = new Cropper($image[0], {
        aspectRatio: 300 / 442,
        autoCropArea: 1,
        zoomable: false,
        highlight: false,
        viewMode: 1,
        crop: function (event) {
            console.log(event.detail.x);
            console.log(event.detail.y);
            console.log(event.detail.width);
            console.log(event.detail.height);
            console.log(event.detail.rotate);
            console.log(event.detail.scaleX);
            console.log(event.detail.scaleY);
        }
    });

// Get the Cropper.js instance after initialized
    var cropper = $image.data('cropper');
}

//inicializace crop landscape
var $image = $('#crop_landscape');

if ($image.length) {
    cropper = new Cropper($image[0], {
        aspectRatio: 16 / 9,
        autoCropArea: 1,
        zoomable: false,
        highlight: false,
        viewMode: 1,
        crop: function (event) {
            console.log(event.detail.x);
            console.log(event.detail.y);
            console.log(event.detail.width);
            console.log(event.detail.height);
            console.log(event.detail.rotate);
            console.log(event.detail.scaleX);
            console.log(event.detail.scaleY);
        }
    });

// Get the Cropper.js instance after initialized
    var cropper = $image.data('cropper');
}

//inicializace crop ultra-wide
var $image = $('#crop_ultrawide');
if ($image.length) {
    cropper = new Cropper($image[0], {
        aspectRatio: 480 / 105,
        autoCropArea: 1,
        zoomable: false,
        highlight: false,
        viewMode: 1,
        crop: function (event) {
            console.log(event.detail.x);
            console.log(event.detail.y);
            console.log(event.detail.width);
            console.log(event.detail.height);
            console.log(event.detail.rotate);
            console.log(event.detail.scaleX);
            console.log(event.detail.scaleY);
        }
    });

// Get the Cropper.js instance after initialized
    var cropper = $image.data('cropper');
}


// Select 2
$(document).ready(function() {
    $('.select_search').select2();
});


// Zobrazení help popupu u služeb
/*$(document).ready(function() {
    var showTimeout;

    // Při najetí na .service_values_item
    $('.service_values_item').mouseenter(function() {
        var $popup = $(this).find('.help_popup');
        
        // Nastavení časovače pro zobrazení popupu
        showTimeout = setTimeout(function() {
            $popup.show();
        }, 500);
    });

    // Při opuštění .service_values_item
    $('.service_values_item').mouseleave(function() {
        var $popup = $(this).find('.help_popup');

        // Zrušení zobrazení, pokud časovač ještě nevypršel
        clearTimeout(showTimeout);

        // Okamžité skrytí popupu
        $popup.hide();
    });
});*/


// Zobrazení/skrytí detailu služby
$(document).ready(function() {
    // Defaultně skryjeme všechny .service_values_list
    $('.service_list_popup .service_values_list').hide();

    // Klik pouze na .service_header
    $('.service_list_popup .service_header').on('click', function(e) {
        // Zkontrolujeme, jestli bylo kliknuto přímo na .service_header
        if ($(e.target).is('.service_list_popup .service_header')) {
            var $header = $(this);
            var $serviceValuesList = $header.next('.service_list_popup .service_values_list');

            // Přepnutí zobrazení service_values_list (toggle)
            $serviceValuesList.slideToggle(150, function() {
                // Pokud je service_values_list viditelný, přidáme třídy 'active' na oba elementy
                if ($serviceValuesList.is(':visible')) {
                    $header.addClass('active');
                    $serviceValuesList.addClass('active');
                } else {
                    // Při skrytí odstraníme třídu 'active' z obou elementů
                    $header.removeClass('active');
                    $serviceValuesList.removeClass('active');
                }
            });
        }
    });

    // Zabráníme zavírání při kliknutí na vnořené elementy uvnitř .service_header
    $('.service_list_popup .service_header').children().on('click', function(e) {
        e.stopPropagation(); // Zastaví propagační řetězec, takže se .service_header neotevře ani nezavře
    });
});


// JS: synchronizace native scrollbar <-> obsah
(function () {
  const content = document.getElementById('contentBox');
  const nativeBar = document.getElementById('nativeScrollbar');

  if (!content || !nativeBar) return;

  const nativeInner = nativeBar.querySelector('.native-scrollbar-inner');
  if (!nativeInner) return;

  let isSyncingFromNative = false;
  let isSyncingFromContent = false;

  // aktualizuje šířku vnitřního elementu tak, aby nativní scrollbar správně ukazoval poměr
  function updateNativeWidth() {
    // scrollWidth obsahu (celková šířka včetně overflow)
    const totalWidth = content.scrollWidth;
    const visibleWidth = content.clientWidth;

    // délka scrollbar tracku (šířka containeru nativeBar)
    const barWidth = nativeBar.clientWidth;

    // pokud není overflow (není co scrollovat), schovej nativeBar
    if (totalWidth <= visibleWidth) {
      nativeBar.style.display = 'none';
      return;
    } else {
      nativeBar.style.display = '';
    }

    // urči, jak široký má být vnitřní element, aby vznikl správný thumb
    // poměr thumb / track = visibleWidth / totalWidth
    // chceme nastavit innerWidth tak, aby track generoval odpovídající thumb
    // innerWidth = barWidth * (totalWidth / visibleWidth)
    const innerWidth = Math.max(barWidth * (totalWidth / visibleWidth), barWidth + 1);
    nativeInner.style.width = Math.ceil(innerWidth) + 'px';

    // synchronizuj pozici (pokud už bylo scrollnuto)
    syncFromContent();
  }

  // při scrollu nativního scrollbaru nastavíme scrollLeft obsahu
  nativeBar.addEventListener('scroll', () => {
    if (isSyncingFromContent) return;
    isSyncingFromNative = true;
    const ratio = nativeBar.scrollLeft / (nativeInner.clientWidth - nativeBar.clientWidth);
    content.scrollLeft = ratio * (content.scrollWidth - content.clientWidth);
    // malé timeouty pro odstranění flátru
    setTimeout(() => { isSyncingFromNative = false; }, 0);
  });

  // při scrollu obsahu posuň nativní scrollbar
  function syncFromContent() {
    if (isSyncingFromNative) return;
    isSyncingFromContent = true;
    const ratio = content.scrollLeft / (content.scrollWidth - content.clientWidth);
    nativeBar.scrollLeft = ratio * (nativeInner.clientWidth - nativeBar.clientWidth);
    setTimeout(() => { isSyncingFromContent = false; }, 0);
  }

  content.addEventListener('scroll', syncFromContent);

  // reaguj na změny velikosti obsahu nebo okna
  const ro = new ResizeObserver(updateNativeWidth);
  ro.observe(content);
  // pokud vnitřní obsah dynamicky mění scrollWidth (např. přidání kartičky),
  // je dobré také sledovat vnitřní elementy
  const inner = content.querySelector('.inner-row') || content;
  if (inner) ro.observe(inner);

  window.addEventListener('resize', updateNativeWidth);

  // initial
  updateNativeWidth();
})();


// rozbalení profile images
$(function () {

    console.log('JS běží');

    $('.profile_images_block').each(function () {

        const $block = $(this);
        const $box = $block.find('.profile_images');
        const $btn = $block.find('.expand_profile_images');

        if (!$box.length || !$btn.length) return;

        const COLLAPSED_HEIGHT = 140;
        let expanded = false;

        // výchozí stav
        $box.css('max-height', COLLAPSED_HEIGHT + 'px');

        // pokud není co rozbalovat → schovat tlačítko
        if ($box[0].scrollHeight <= COLLAPSED_HEIGHT) {
            $btn.hide();
            return;
        }

        $btn.on('click', function () {

            if (!expanded) {
                // ROZBALENÍ
                const fullHeight = $box[0].scrollHeight;

                $box
                    .addClass('expanded')
                    .css('max-height', fullHeight + 'px');

                $btn.text('Skrýt další');
                expanded = true;

            } else {
                // SBALENÍ
                $box
                    .removeClass('expanded')
                    .css('max-height', COLLAPSED_HEIGHT + 'px');

                $btn.text('Zobrazit další');
                expanded = false;
            }
        });
    });
});


// Zobrazení help popupu
$(function () {

    let activeTrigger = null;
    let activePopup = null;
    let hideTimeout = null;

    const GAP = 15;
    const VIEWPORT_MARGIN = 10;


    /*
     * ========================================
     * NAJDE TOOLTIP PRO DANÝ SPOUŠTĚČ
     * ========================================
     */

    function getPopup($trigger) {

        /*
         * Tooltip, který už byl přesunut do body.
         */
        const popupId =
            $trigger.attr('data-tooltip-id');

        if (popupId) {

            const $bodyPopup =
                $('#' + popupId);

            if ($bodyPopup.length) {
                return $bodyPopup;
            }
        }


        /*
         * Tooltip uvnitř spouštěče.
         */
        let $popup =
            $trigger.find('.help_popup').first();

        if ($popup.length) {
            return $popup;
        }


        /*
         * Tooltip jako sourozenec.
         */
        $popup =
            $trigger.siblings('.help_popup').first();

        if ($popup.length) {
            return $popup;
        }


        /*
         * Tooltip uvnitř service_values_item.
         */
        if ($trigger.hasClass('service_values_item')) {

            $popup =
                $trigger.find('.help_popup').first();

            if ($popup.length) {
                return $popup;
            }
        }


        return $();
    }


    /*
     * ========================================
     * ZJISTÍ, ZDA JE TOOLTIP UVNITŘ
     * TRANSFORMOVANÉHO ELEMENTU
     * ========================================
     */

    function needsMoveToBody($popup) {

        let $parent =
            $popup.parent();

        while (
            $parent.length &&
            $parent[0] !== document.body
        ) {

            const style =
                window.getComputedStyle(
                    $parent[0]
                );


            /*
             * transform
             */
            if (
                style.transform &&
                style.transform !== 'none'
            ) {
                return true;
            }


            /*
             * perspective
             */
            if (
                style.perspective &&
                style.perspective !== 'none'
            ) {
                return true;
            }


            /*
             * filter
             */
            if (
                style.filter &&
                style.filter !== 'none'
            ) {
                return true;
            }


            /*
             * backdrop-filter
             */
            if (
                style.backdropFilter &&
                style.backdropFilter !== 'none'
            ) {
                return true;
            }


            /*
             * contain
             */
            if (
                style.contain &&
                style.contain !== 'none'
            ) {
                return true;
            }


            /*
             * will-change: transform
             */
            if (
                style.willChange &&
                style.willChange.includes('transform')
            ) {
                return true;
            }


            $parent =
                $parent.parent();
        }


        return false;
    }


    /*
     * ========================================
     * PŘESUN TOOLTIPU DO BODY
     * ========================================
     */

    function movePopupToBody(
        $trigger,
        $popup
    ) {

        /*
         * Pokud už je tooltip v body,
         * nic dalšího neděláme.
         */
        if (
            $popup.parent()[0] ===
            document.body
        ) {
            return;
        }


        /*
         * Zachováme aktuální vypočtenou šířku.
         */
        const computedStyle =
            window.getComputedStyle(
                $popup[0]
            );

        const computedWidth =
            computedStyle.width;


        /*
         * Vytvoříme ID, pokud ho tooltip nemá.
         */
        let popupId =
            $popup.attr('id');

        if (!popupId) {

            popupId =
                'help-popup-' +
                Math.random()
                    .toString(36)
                    .substring(2, 11);

            $popup.attr(
                'id',
                popupId
            );
        }


        /*
         * Uložíme ID na trigger.
         */
        $trigger.attr(
            'data-tooltip-id',
            popupId
        );


        /*
         * Označíme tooltip jako přesunutý.
         */
        $popup.attr(
            'data-moved-to-body',
            'true'
        );


        /*
         * Zachováme vypočtenou šířku.
         */
        if (
            computedWidth &&
            computedWidth !== 'auto'
        ) {

            $popup.css(
                'width',
                computedWidth
            );
        }


        /*
         * Přesuneme tooltip do body.
         */
        $('body').append(
            $popup
        );
    }


    /*
     * ========================================
     * NAJDE SPOUŠTĚČ PRO DANÝ TOOLTIP
     * ========================================
     */

    function getTriggerFromPopup($popup) {

        /*
         * Tooltip přesunutý do body.
         */
        const popupId =
            $popup.attr('id');

        if (popupId) {

            const $trigger =
                $('[data-tooltip-id="' +
                    popupId +
                    '"]')
                    .first();

            if ($trigger.length) {
                return $trigger;
            }
        }


        /*
         * Tooltip uvnitř .dotted.
         */
        let $trigger =
            $popup.closest('.dotted');

        if ($trigger.length) {
            return $trigger;
        }


        /*
         * Tooltip uvnitř service_values_item.
         */
        $trigger =
            $popup.closest(
                '.service_values_item'
            );

        if ($trigger.length) {
            return $trigger;
        }


        /*
         * Tooltip jako sourozenec .dotted.
         */
        $trigger =
            $popup.siblings(
                '.dotted'
            ).first();

        if ($trigger.length) {
            return $trigger;
        }


        /*
         * Tooltip jako sourozenec service_values_item.
         */
        $trigger =
            $popup.siblings(
                '.service_values_item'
            ).first();

        if ($trigger.length) {
            return $trigger;
        }


        return $();
    }


    /*
     * ========================================
     * POZICOVÁNÍ TOOLTIPU
     * ========================================
     */

    function positionHelpPopup(
        $trigger,
        $popup
    ) {

        if (!$popup.length) {
            return;
        }


        /*
         * Pozice triggeru vůči viewportu.
         */
        const triggerRect =
            $trigger[0]
                .getBoundingClientRect();


        const viewportWidth =
            window.innerWidth;

        const viewportHeight =
            window.innerHeight;


        /*
         * Zobrazíme tooltip pouze kvůli změření
         * skutečné velikosti.
         */
        $popup.css({
            display: 'block',
            visibility: 'hidden',
            position: 'fixed',
            left: '0px',
            top: '0px'
        });


        let popupRect =
            $popup[0]
                .getBoundingClientRect();


        let popupWidth =
            popupRect.width;

        let popupHeight =
            popupRect.height;


        /*
         * ========================================
         * MAXIMÁLNÍ ŠÍŘKA
         * ========================================
         */

        if (
            popupWidth >
            viewportWidth -
            (VIEWPORT_MARGIN * 2)
        ) {

            $popup.css({
                maxWidth:
                    `${viewportWidth -
                    (VIEWPORT_MARGIN * 2)}px`
            });


            popupRect =
                $popup[0]
                    .getBoundingClientRect();


            popupWidth =
                popupRect.width;

            popupHeight =
                popupRect.height;
        }


        /*
         * ========================================
         * VERTIKÁLNÍ POZICE
         * ========================================
         *
         * Výchozí:
         * nahoře.
         *
         * Pokud se nahoru nevejde:
         * dolů.
         */

        let top;
        let verticalPosition;


        const spaceAbove =
            triggerRect.top -
            GAP;


        const spaceBelow =
            viewportHeight -
            triggerRect.bottom -
            GAP;


        if (
            spaceAbove >= popupHeight
        ) {

            top =
                triggerRect.top -
                popupHeight -
                GAP;

            verticalPosition =
                'top';

        }

        else if (
            spaceBelow >= popupHeight
        ) {

            top =
                triggerRect.bottom +
                GAP;

            verticalPosition =
                'bottom';

        }

        else if (
            spaceAbove >= spaceBelow
        ) {

            /*
             * Nevejde se ani nahoru ani dolů.
             * Použijeme stranu s větším prostorem.
             */

            top = Math.max(
                VIEWPORT_MARGIN,
                triggerRect.top -
                popupHeight -
                GAP
            );

            verticalPosition =
                'top';

        }

        else {

            top =
                triggerRect.bottom +
                GAP;

            verticalPosition =
                'bottom';
        }


        /*
         * ========================================
         * HORIZONTÁLNÍ POZICE
         * ========================================
         *
         * Výchozí:
         * vlevo.
         *
         * Pokud se tooltip nevejde doprava,
         * zarovnáme ho zprava.
         */

        let left;
        let horizontalPosition;


        /*
         * Výchozí pozice:
         * levý okraj tooltipu =
         * levý okraj triggeru.
         */

        left = triggerRect.left - 9;

        horizontalPosition =
            'left';


        /*
         * Pokud by tooltip přetékal doprava,
         * zarovnáme jeho pravý okraj
         * s pravým okrajem triggeru.
         */

        if (
            left + popupWidth >
            viewportWidth -
            VIEWPORT_MARGIN
        ) {

            left = triggerRect.right - popupWidth + 3;

            horizontalPosition =
                'right';
        }


        /*
         * Pokud je tooltip širší než prostor
         * a vyšel by vlevo mimo viewport,
         * ochráníme levý okraj.
         */

        if (
            left < VIEWPORT_MARGIN
        ) {

            left =
                VIEWPORT_MARGIN;
        }


        /*
         * ========================================
         * APLIKACE POZICE
         * ========================================
         */

        $popup
            .removeClass(
                'popup--top ' +
                'popup--bottom ' +
                'popup--left ' +
                'popup--right'
            )
            .addClass(
                verticalPosition === 'top'
                    ? 'popup--top'
                    : 'popup--bottom'
            )
            .addClass(
                horizontalPosition === 'left'
                    ? 'popup--left'
                    : 'popup--right'
            )
            .css({

                left:
                    `${left}px`,

                top:
                    `${top}px`,

                visibility:
                    'visible'
            });
    }


    /*
     * ========================================
     * ZOBRAZENÍ TOOLTIPU
     * ========================================
     */

    function showPopup($trigger) {

        clearTimeout(
            hideTimeout
        );


        const $popup =
            getPopup($trigger);


        if (!$popup.length) {
            return;
        }


        /*
         * Zavřeme všechny ostatní tooltipy.
         */
        $('.help_popup')
            .not($popup)
            .hide();


        /*
         * Tooltip přesuneme do body POUZE tehdy,
         * pokud je uvnitř elementu, který vytváří
         * containing block pro position: fixed.
         */
        if (
            needsMoveToBody($popup)
        ) {

            movePopupToBody(
                $trigger,
                $popup
            );
        }


        activeTrigger =
            $trigger;

        activePopup =
            $popup;


        positionHelpPopup(
            $trigger,
            $popup
        );
    }


    /*
     * ========================================
     * SKRYTÍ TOOLTIPU
     * ========================================
     */

    function hidePopup($trigger) {

        clearTimeout(
            hideTimeout
        );


        hideTimeout =
            setTimeout(function () {

                /*
                 * Pokud uživatel mezitím přešel
                 * na jiný trigger, nic neděláme.
                 */

                if (
                    activeTrigger &&
                    activeTrigger.is($trigger)
                ) {

                    const $popup =
                        getPopup($trigger);


                    $popup.hide();


                    activeTrigger =
                        null;

                    activePopup =
                        null;
                }

            }, 100);
    }


    /*
     * ========================================
     * DOTTED
     * ========================================
     *
     * .dotted má vlastní tooltip.
     *
     * Delegace na document, aby fungovaly
     * i elementy vykreslené Vue až po načtení.
     */

    $(document).on(
        'mouseenter',
        '.dotted',
        function () {

            const $trigger =
                $(this);


            if (!getPopup($trigger).length) {
                return;
            }


            showPopup(
                $trigger
            );
        }
    );


    $(document).on(
        'mouseleave',
        '.dotted',
        function () {

            const $trigger =
                $(this);


            if (!getPopup($trigger).length) {
                return;
            }


            hidePopup(
                $trigger
            );
        }
    );


    /*
     * ========================================
     * SERVICE VALUES ITEM
     * ========================================
     *
     * Celý service_values_item je trigger.
     *
     * Delegace na document, aby fungovaly
     * i elementy vykreslené Vue až po načtení.
     */

    $(document).on(
        'mouseenter',
        '.service_values_item',
        function (event) {

            const $trigger =
                $(this);


            if (!getPopup($trigger).length) {
                return;
            }


            /*
             * Pokud jsme najeli na .dotted,
             * který má vlastní tooltip,
             * necháme ho řešit vlastní tooltip.
             */

            const $dotted =
                $(event.target)
                    .closest('.dotted');


            if (
                $dotted.length &&
                getPopup($dotted).length
            ) {
                return;
            }


            showPopup(
                $trigger
            );
        }
    );


    $(document).on(
        'mouseleave',
        '.service_values_item',
        function () {

            const $trigger =
                $(this);


            if (!getPopup($trigger).length) {
                return;
            }


            hidePopup(
                $trigger
            );
        }
    );


    /*
     * ========================================
     * HOVER PŘÍMO NA TOOLTIPU
     * ========================================
     */

    $(document).on(
        'mouseenter',
        '.help_popup',
        function () {

            clearTimeout(
                hideTimeout
            );


            const $popup =
                $(this);


            const $trigger =
                getTriggerFromPopup(
                    $popup
                );


            if ($trigger.length) {

                activeTrigger =
                    $trigger;

                activePopup =
                    $popup;
            }
        }
    );


    $(document).on(
        'mouseleave',
        '.help_popup',
        function () {

            const $popup =
                $(this);


            const $trigger =
                getTriggerFromPopup(
                    $popup
                );


            if ($trigger.length) {

                hidePopup(
                    $trigger
                );
            }
        }
    );


    /*
     * ========================================
     * RESIZE + SCROLL
     * ========================================
     */

    $(window).on(
        'resize scroll',
        function () {

            if (
                activeTrigger &&
                activePopup
            ) {

                positionHelpPopup(
                    activeTrigger,
                    activePopup
                );
            }
        }
    );

});


// WEBPACK FOOTER //
// ./src/assets/js/custom.js